import { isSameDomain } from '../utils.js';

export default function (name, opts) {
  const widgetName = name;
  const widgetOpts = opts;

  const maxItemsVisible = widgetName === 'cardWidgetEventMode' ? 8 : 4;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'],
    maxItemsVisible: maxItemsVisible,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
        $('.tier-two .left-module').remove();
      } else {
        addButtonClass(widgetName);
        createOverlay(widgetName);
        optimizeLinks(widgetName, data);
        isSameDomain(data, widgetName);
      }
    },
  });
}

// Add class to style widget buttons
function addButtonClass(widgetName) {
  $(`#${widgetName} .buttonwrap a`).addClass('button');
}

// Create an overlay for animation effects
function createOverlay(widgetName) {
  $(`#${widgetName} .card-widget-item .image-container`).each(function () {
    $(this).find('.card-content').before('<div class="overlay"></div>');
  });
}

// Remove buttonwrap if empty and href if there is no link
function optimizeLinks(widgetName, data) {
  $(`#${widgetName} .buttonwrap`).each(function () {
    if ($.trim($(this).html()) === '') {
      $(this).remove();
    }
  });

  $(`#${widgetName} .card-widget-item`).each(function (index) {
    if (!data.items[index]?.URL) {
      $(this).removeAttr('href');
    }
  });
}
